import React from 'react';

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

// A–Z jump bar — letters with no matching people are dimmed and disabled
export const DirectoryAlphaBar = ({ present, active, onSelect }) => (
  <div className="flex items-center gap-1 overflow-x-auto no-scrollbar" data-testid="dir-alpha-bar">
    <span className="text-[9px] tracking-[0.2em] uppercase text-white/35 font-semibold flex-shrink-0 w-20">Jump to</span>
    <button type="button" onClick={() => onSelect(null)} data-testid="dir-alpha-all"
      className={`px-2 h-7 rounded-lg text-[10px] font-semibold transition-colors ${!active ? 'bg-cyan-500/20 text-cyan-100' : 'text-white/45 hover:text-white'}`}>All</button>
    {LETTERS.map(l => {
      const has = present.has(l);
      const on = active === l;
      return (
        <button key={l} type="button" disabled={!has} onClick={() => onSelect(on ? null : l)} data-testid={`dir-alpha-${l}`}
          className={`w-7 h-7 flex-shrink-0 rounded-lg text-[11px] font-semibold transition-colors ${on ? 'bg-gradient-to-br from-cyan-400 to-violet-500 text-[#0a0a14]' : has ? 'text-white/70 hover:bg-white/[0.06] hover:text-white' : 'text-white/15 cursor-not-allowed'}`}>
          {l}
        </button>
      );
    })}
  </div>
);
